const ww = window.innerWidth
const wh = window.innerHeight

// 找出场景三时钟中心位置
const s3BgW = wh * 2600 / 2436
const s3BgScrollW = s3BgW - ww
const s3DoorW = wh * 0.511 * 704 / 1244
const s3DoorX = 470 * s3BgW / 2600
const s3ClockH = wh * 0.1
const s3ClockX = s3DoorX + s3DoorW + 1034 / 2600 * s3BgW + s3ClockH / 2 - s3BgScrollW
const s3ClockY = 0.243 * wh + s3ClockH / 2
// 场景
const s4StaticH = s3ClockH / (243 / 3980)
const s4StaticW = s4StaticH * 3819 / 3980
// 场景四时钟中心位置
const s4StaticCX = s4StaticW * 1364 / 3819
const s4StaticCY = s4StaticH * 610 / 3980
// 场景四起始偏移值
const s4StaticX = s3ClockX - s4StaticCX
const s4StaticY = s3ClockY - s4StaticCY

const sprites = {
  s4_staticnew: {
    size: { mode: 'heightFit', height: s4StaticH / wh },
    position: { x: s4StaticX / ww, y: s4StaticY / wh },
    anchor: 'topLeft'
  },
  s4_page: {
    key: 's4_page1',
    size: { mode: 'widthFit', width: 1 },
    position: 'bottomRight',
    anchor: 'bottomRight'
  },
  s4_text: {
    size: { mode: 'heightFit', height: 900 / 2436 },
    position: { x: 800 / 1125, y: 240 / 2436 },
    anchor: 'topLeft'
  },
  s4_talk: {
    size: { mode: 'heightFit', height: 727 / 2436 },
    position: { x: 0.5, y: 0.4 },
    anchor: 'bottomLeft'
  }
}

export default sprites



// WEBPACK FOOTER //
// ./src/assets/scenes/s4/sprites.js